import SigliveServiceV3 from 'Service/sigliveServiceV3';

const patchTarget = async ({ id, payload }) => {
  const { data } = await SigliveServiceV3({ method: 'PATCH', url: `/target/${id}`, data: payload });

  return data;
};

export default patchTarget;
